import { render, staticRenderFns } from "./aloneAsGroup.vue?vue&type=template&id=e08f2406&scoped=true&"
import script from "./aloneAsGroup.vue?vue&type=script&lang=ts&"
export * from "./aloneAsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./aloneAsGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./aloneAsGroup.vue?vue&type=style&index=1&id=e08f2406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08f2406",
  null
  
)

export default component.exports